<template>

  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" @click="cancel">{{ t("Cancel") }}</ion-button>
      </ion-buttons>
      <ion-title>{{ t("Repertoire Selector") }}</ion-title>
      <ion-buttons slot="end">
        <ion-button @click="confirm" :strong="true">{{ t("Done") }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding" color="light">

    <div :class="{ 'text-light' : isDark,'text-dark' : !isDark, 'repselector-center-text' : true ,
                    'repselector-heading-color' : true }" >
      {{ descriptionHeading }}
    </div>
    <div v-if="showPracticeHeading" >
      <div :class="{ 'text-light' : isDark,'text-dark' : !isDark ,
                      'repselector-heading-color' : true }">
        *** {{ practiceHeading }} ***
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" v-model="practiceAsWhite"
            id=practiceColor @change="onPracticeClick($event,'practice',0)">
        <label class="form-check-label" for=item.name>
          {{ practiceSwitchLabel }}
        </label>
      </div>
    </div>

    <div :class="{ 'text-light' : isDark,'text-dark' : !isDark ,
                  'repselector-heading-color' : true }">
      *** {{ whiteHeading}} ***
    </div>
    <div v-for="item in whiteRepertoires" v-bind:key="item.id">
      <div class="form-check">
        <input v-if="showPracticeHeading" class="form-check-input" type="checkbox" value="" 
                id=item.name @change="onPracticeClick($event,'white',item.index)"
                v-model="whiteRepertoires[item.index].practice">

          <input v-if="!showPracticeHeading" class="form-check-input" type="radio" :value="item.radio"
                @change="onClick($event,'white',item.index)"
                v-model="selectedId">

        <label v-if="showPracticeHeading" class="form-check-label" for=item.name>
          {{ item.name }}
        </label>
        <label v-if="!showPracticeHeading" class="" for=item.name>
          {{ item.name }}
        </label>
      </div>
    </div>

    <div :class="{ 'text-light' : isDark,'text-dark' : !isDark ,
                  'repselector-heading-color' : true}">
      *** {{ blackHeading}} ***
    </div>

    <div v-for="item in blackRepertoires" v-bind:key="item.id">
      <div class="form-check">
        <input v-if="showPracticeHeading" class="form-check-input" type="checkbox" value="" 
                @change="onPracticeClick($event,'black',item.index)"
                id=item.name v-model="blackRepertoires[item.index].practice">

        <input v-if="!showPracticeHeading" class="form-check-input" type="radio" :value="item.radio"
                @change="onClick($event,'black',item.index)"
                v-model="selectedId">

        <label v-if="showPracticeHeading" class="form-check-label" for=item.name>
          {{ item.name }}
        </label>
        <label v-if="!showPracticeHeading">
          {{ item.name }}
        </label>
      </div>
    </div>

    <div v-show="unknownRepertoires.length > 0">
      <div :class="{ 'text-light' : isDark,'text-dark' : !isDark ,
                    'repselector-heading-color' : true}">
        *** {{ unknownHeading}} ***
      </div>
      <div v-for="item in unknownRepertoires" v-bind:key="item.id">
        {{ item.name }}
      </div>
    </div>
  </ion-content>
</template>
  
<script setup>

  import {
    IonRow,
    IonCol,
    IonRadio,
    IonRadioGroup,
    IonRange,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    IonItem,
    IonInput,
    IonCheckbox,
    IonLabel,
    modalController,
  } from '@ionic/vue';

  import { defineComponent, ref } from 'vue';
  import { useGetData } from '@/composables/getData.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { t } from '@/composables/translateText.js'

  const connectionStore = useConnectionStore()

  const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light")

  const hasChanges = ref(false)

  const props = defineProps({
    descriptionHeading : {
      type : String,
      default : ""
    },
    whoCalled : {
      type : String,
      default : "practice"
    },
    downloadID : {
      type : String,
      default : "0"
    }
  })

  var changesMade = false
  var initialValues = []
  const resultsData = ref([])

  const practiceAsWhite = ref(true)
  const selectedId = ref("")

  const whiteRepertoires = ref([])
  const blackRepertoires = ref([])
  const unknownRepertoires = ref([])
  const showPracticeHeading = ref(props.whoCalled == "practice")
  var selectedRepertoireName = ""

  //console.log("who called",props.whoCalled,showPracticeHeading.value)
  const practiceHeading = ref(t("Select Side to Play"))
  const practiceSwitchLabel = ref(t("Practice Playing White"))
  const whiteHeading = ref(t("Playing White"))
  const blackHeading = ref(t("Playing Black"))
  const unknownHeading = ref(t("Imported - Must Assign Color Before Use"))

  // import sends a particular ID #
  getRepertoireManager( props.downloadID != "0" ? "2" : "1",props.downloadID)

  const cancel = () => modalController.dismiss(null, 'cancel');

  function confirm() {
    var result = { 
      changed : hasChanges.value
    }

    //console.log("CONFIRM",result)
    modalController.dismiss(result, 'confirm');
  }

  function onClick(event,color,index) {
    var slotID = "edit"
    hasChanges.value = true
    //console.log("click",color,index,selectedId.value,selectedId.value)
    switch (color) {
      case "white" :
        //console.log("selected ",whiteRepertoires.value[index].id,whiteRepertoires.value[index].name)
        setRepertoireId(slotID,whiteRepertoires.value[index].id)
        selectedRepertoireName = whiteRepertoires.value[index].name
        break;
      case "black" :
        //console.log("selected ",blackRepertoires.value[index].id,blackRepertoires.value[index].name)
        setRepertoireId(slotID,blackRepertoires.value[index].id)
        selectedRepertoireName = blackRepertoires.value[index].name
        break;
    }
  }

  function onPracticeClick(event,color,index) {
    hasChanges.value = true
    //console.log("practice click",color,index)
    switch (color) {
      case "practice" :
        //console.log("practice", practiceAsWhite.value)
        setPracticeCheckbox(0,practiceAsWhite.value)
        break;
      case "white" :
        //console.log("white", index, whiteRepertoires.value[index].practice)
        setPracticeCheckbox(whiteRepertoires.value[index].id, whiteRepertoires.value[index].practice)
        break;
      case "black" :
        //console.log("black", index, blackRepertoires.value[index].practice)
        setPracticeCheckbox(blackRepertoires.value[index].id, blackRepertoires.value[index].practice)
        break;
    }
  }

  function processJsonResponse(json) {
    //console.log("repertoire manager json",json)
    if (json.hasOwnProperty('error')) {
      alert("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }
    //console.log("*** process Game Collection ***")

    practiceAsWhite.value = json['practice_as_white'] == 1

    selectedId.value = "" + json['selected_id']

    const whiteCount = json['white_count']
    const whiteId = json['white_id'].split("\t")
    const whiteName = json['white_name'].split("\t")
    const whitePractice = json['white_practice'].split("\t")

    for (var i = 0; i < whiteCount; i++) {
      whiteRepertoires.value.push({ 
              index : i,
              id : whiteId[i],
              name : whiteName[i],
              practice : whitePractice[i] == 1,
              radio : "" + whiteId[i]
            })
    }
    const blackCount = json['black_count']
    const blackId = json['black_id'].split("\t")
    const blackName = json['black_name'].split("\t")
    const blackPractice = json['black_practice'].split("\t")

    for (var i = 0; i < blackCount; i++)
      blackRepertoires.value.push({ 
              index : i,
              id : blackId[i],
              name : blackName[i],
              practice : blackPractice[i] == 1,
              radio : "" + blackId[i]
            })
      //console.log("black   ",blackRepertoires.value)

    const unknownCount = json['unknown_count']
    const unknownId = json['unknown_id'].split("\t")
    const unknownName = json['unknown_name'].split("\t")

    for (var i = 0; i < unknownCount; i++)
      unknownRepertoires.value.push({ 
              index : i,
              id : unknownId[i],
              name : unknownName[i],
              practice : false
      })
      //console.log("unknown   ",unknownRepertoires.value)
      
  }

  function getRepertoireManager(action,download_id) {
    var formData = {
      action : action,
      download : download_id
    }
    //console.log("before get repertoire manager ",formData)
    useGetData("get2_repertoire_manager.php", formData, processJsonResponse)
  }

  function setRepertoireId(slotID,repertoireId) {
    var formData = {
      slot_id : slotID,
      id : repertoireId
    }
    //console.log("before set rep ",formData)
    useGetData("set2_repertoire_id.php", formData, processSetRepertoireJsonResponse)
  }

  function processSetRepertoireJsonResponse(json) {
    //console.log("set repertoire json",json)
    if (json.hasOwnProperty('error')) {
      alert("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }
  }

  function processSetPracticeJsonResponse(json) {
    //console.log("set practice checkbox json",json)
    if (json.hasOwnProperty('error')) {
      alert("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }
  }
  function setPracticeCheckbox(id,isOn) {
    var formData = {
      repid : id,
      is_on : (isOn) ? 1 : 0
    }
    //console.log("before set practice checkbox",formData)
    useGetData("set2_practice_checkbox.php", formData, processSetPracticeJsonResponse)
  }

</script>

<style scoped>

/*
https://stackoverflow.com/questions/10980822/scrollbar-without-fixed-height-dynamic-height-with-scrollbar
*/

/*
    https://getbootstrap.com/docs/5.0/forms/checks-radios/
*/

#repselector-container {
  position : relative;
  border-style : solid;
  border-width: 2px;
  margin : 30px auto;
  padding : 15px 15px;
  line-height: 1.4em;
  width : 600px;
  height: calc(100vh - 125px);
  overflow-y: auto;
}

/* from bootstrap */

.form-check {
    display: block;
    min-height: 1.5rem;
    padding-left: 1.5em;
    margin-bottom: 0.125rem;
    line-height: 1.4em;
}

.form-check-input[type=checkbox] {
    border-radius: 0.25em;
}

.form-check-input:checked {
    background-color: #0d6efd;
    border-color: #0d6efd;
}

.form-check-input:checked[type=checkbox] {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3E%3C/svg%3E");
}

.form-check-input:disabled {
    pointer-events: none;
    filter: none;
    opacity: .5;
}

.form-check .form-check-input {
    float: left;
    margin-left: -1.5em;
}

.form-check-input {
    width: 1em;
    height: 1em;
    margin-top: 0.25em;
    vertical-align: top;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: contain;
    border: 1px solid rgba(0,0,0,.25);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
}

.repselector-center-text {
  text-align: center;
  margin-bottom : 10px;
  font-style :italic;
}

.repselector-heading-color {
  background: #4c6ca0;
  color : white;
}

/* from bootstrap */

.form-check-input:checked[type=radio] {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e");
}

.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-check-input[type=radio] {
  border-radius: 50%;
}

.form-check .form-check-input {
  float: left;
  margin-left: -1.5em
em
;
}
.form-check-input {
width: 1em;
  height: 1em;
  margin-top: .25em;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0,0,0,.25);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
</style>